import React from "react";
import _Select, { Props } from "react-select";
import _Async, { AsyncProps } from "react-select/async";

export function Select<T>(props: Props<T>) {
  return (
    <_Select
      classNamePrefix="vseth-react-select"
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
        },
      })}
      {...props}
    />
  );
}

export function Async<T>(props: Props<T> & AsyncProps<T>) {
  return (
    <_Async
      classNamePrefix="vseth-react-select"
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
        },
      })}
      {...props}
    />
  );
}
